const subToggle = $("#onpage-toggle");
const subDrawer = $(".parent-child-menu-block");

$(window).on("load", function() {
	resetAllSub();
	subToggle.on("click", function(){
		toggleAllSub();
	});
});

$(window).on("resize", function() {
	resetAllSub();
});

const toggleAllSub = function() {
	if (subToggle.hasClass("open")) {
		resetAll();
	} else {
		subToggle.addClass("open");
		subDrawer.addClass("toggle-open");
		subToggle.attr("aria-expanded", "true");
	}
};

const resetAllSub = function() {
	subToggle.removeClass("open");
	subDrawer.removeClass("toggle-open");
	subToggle.attr("aria-expanded", "false");
	$('#current-submenu').hide();
}

// Dropdown button clicks
$('#onpage-toggle').on('click', function( event ) {
	event.preventDefault();
	var $this = $(this);

	$this.siblings('#current-submenu').stop().slideToggle(250);
	if($this.attr("aria-expanded") == 'true'){
		$this.attr("aria-expanded", "false");
	}else{
		$this.attr("aria-expanded", "true");
	}
});
